import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TestService } from 'src/app/_services/test.service';

@Component({
  selector: 'app-record-data',
  templateUrl: './record-data.component.html',
  styleUrls: ['./record-data.component.css']
})
export class RecordDataComponent implements OnInit {
  baseURL: any;
  baseUrlToOpen: any;
  tabList: any;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private testService: TestService,
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<RecordDataComponent>) 
  { 
    this.tabList =  this.data.tabs;
  }
  recordForm:UntypedFormGroup;
  ngOnInit(): void {
    this.loadForm();
  }
 

  loadForm() {
    const isDesktop = this.isDesktopProject;
    const initialMode = (this.data && this.data.mode === 'MOUSE_SEQUENCE')
      ? 'MOUSE_SEQUENCE'
      : 'STEPS';
    this.recordForm = this.formBuilder.group({
      baseUrl: [isDesktop ? 'desktop' : '', isDesktop ? [] : [ Validators.required,
        Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)
      ]],
      recordMode: [initialMode],
    });
  }
  get baseUrl() { return this.recordForm.get('baseUrl') };
  get showMouseSequence() {
    return !(this.data && this.data.showMouseSequence === false);
  }
  get isDesktopProject() {
    const t = this.data && this.data.projectType;
    return t === 'DESKTOP';
  }
  
  openAndStartRecording() {
    var objFormVal = this.recordForm.value;
    this.baseUrlToOpen = objFormVal.baseUrl;
    const mode = objFormVal.recordMode === 'MOUSE_SEQUENCE' ? 'MOUSE_SEQUENCE' : null;
    this.testService.setRecordMode(mode);
    if (this.data) {
      this.data.mode = mode;
    }
    if (this.isDesktopProject) {
      this.dialogRef.close({
        desktop: true,
        desktopMouseSequence: mode === 'MOUSE_SEQUENCE',
        mode: mode
      });
      return;
    }
    this.testService.setRecordingStatus(true);
    this.testService.setRecordingStatusSub(true);
    this.openRecording();
  };
  
  openRecording() {
  var urlToOpen = (this.baseUrlToOpen || '').toString().trim();
  
  // Keep file:// as-is (local HTML test pages). Only prefix bare hosts with http://
  if (!(urlToOpen.startsWith("http://") || urlToOpen.startsWith("https://") || urlToOpen.startsWith("file://"))) {
    urlToOpen = "http://" + urlToOpen;
  }
    this.testService.setRecordingUrl(urlToOpen);
    // Always open a new tab for Record / Mouse Sequence (do not reuse stale tab ids).
    window.postMessage({
        type: "FROM_OPEN_RECORD_PAGE",
        url: urlToOpen,
        tabToOpen: -1,
        tab: null,
        mode: this.testService.getRecordMode()
    }, window.location.origin);
    // Close after posting so the Studio page content-script still receives the message.
    this.dialogRef.close(true);
  };
refreshTabs(){
  window.postMessage({
    type: "CHECK_IF_EXTENSION_INSTALLED"
  }, "*");

}
  closeDialog() {
    this.dialogRef.close(false);
  }

}
